import { c as _c } from "react/compiler-runtime";
import NotFoundIcon from "@assets/illustrations/page-not-found_566px.svg";
import { ErrorPageBase } from "@pages/error-page-base";

/**
 * Page to show whenever the user access a page that we cannot match
 * to a valid page in the router.
 */
export function NotFoundPage() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ErrorPageBase title="Page not found" iconImg={NotFoundIcon}>We couldn’t find the page you are looking for...</ErrorPageBase>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}